export const useLanguageStore = defineStore({
  id: 'language',
  state: () => ({
    languageList: [
      {
        text: 'English', // 英语
        value: 'en'
      },
      {
        text: 'العربية', // 阿拉伯
        value: 'ar'
      },
      {
        text: 'tiếng việt', // 越南语
        value: 'vi'
      },
      {
        text: 'Bahasa', // 印度尼西亚
        value: 'in'
      },
      {
        text: 'Español', // 西班牙语
        value: 'es'
      },
      {
        text: 'Português', // 葡萄牙语
        value: 'pt'
      },
      {
        text: 'ไทย', // 泰语
        value: 'th'
      },
      {
        text: '中文', // 中文
        value: 'zh'
      },
      // {
      //   text: '繁體中文', // 繁體中文
      //   value: 'tw'
      // },
      {
        text: 'Türkçe', // 土耳其
        value: 'tr'
      }
      // {
      //   text: 'हिंदी', // 印度语
      //   value: 'hi'
      // }
      // {
      //   text: 'Русский', // 俄罗斯语
      //   value: 'ru'
      // }
    ],
    languageInfo: {
      text: '',
      value: ''
    } as { text: string; value: string } // 当前语言,默认为英语
  }),
  actions: {
    /**
     * 初始化语言
     */
    initLanguage() {
      if (process.client) {
        const roomStore = useRoomStore()
        const userStore = useUserStore()
        // 先从缓存拿，没有则设空
        let language = userStore.userInfo.language
          ? userStore.userInfo.language.firstLanguage
          : ''
        // 如果缓存没有就拿浏览器
        if (!language) {
          // // 缓存没有就获取浏览器语言
          // const languageCode = common.getBrowserLanguage() as string
          // // 判断是否有符合的
          // const info = this.languageList.find((v) => {
          //   return languageCode.toLowerCase().includes(v.value)
          // })
          // // 浏览器没有有效值就设英语
          // language = info ? info.value : 'en'

          // 暂时隐藏由浏览器语言判断语言，没缓存就拿英语
          language = 'en'
        }

        // 设置语言，没有就设置英文,在APP不初始化
        if (!roomStore.isApp) {
          this.setLanguageInfo(language || 'en')
        }
      }
    },
    /**
     * 设置语言
     * @param {string} language 语言代码或语言,会自行判断是否符合语言列表
     * */
    setLanguageInfo(language: string) {
      // 语言code冲突转换
      switch (language) {
        case 'cn':
          language = 'zh'
          break
      }

      // 判断是有否符合info
      const info = this.languageList.find((v) => {
        return v.text === language || v.value === language
      })
      // 有值才设置
      if (info) {
        common.setLanguage('en')
        this.languageInfo = info
      } else {
        // 没值就设置成英文，这样操作避免错误
        common.setLanguage('en')
        this.languageInfo = {
          text: 'English', // 英语
          value: 'en'
        }
      }
    }
  },
  persist: {
    key: 'languageStore',
    paths: ['language', 'languageInfo']
  }
})
